import React from "react";
import { css } from "@linaria/core";
import Button from "@ui/Button";
import Text from "@ui/Text";
import { spacings } from "@ui/Theme";
import useToasts from "@ui/Toast/useToasts";
import { usePost } from "../../../api/useCall";
import t from "../../../i18n";

export default function PowerOutputCacheAction() {
  const enqueue = usePost("/power-outputs/cache");
  const { addToast } = useToasts();

  const onClick = async () => {
    try {
      await enqueue({});
      addToast("success", t("app.customization.aggregation_period.power_outputs.queued"));
    } catch {
      // usePost displays the request error.
    }
  };

  return (
    <div className={content}>
      <Text type="body2">
        {t("app.customization.aggregation_period.power_outputs.description")}
      </Text>
      <Button variant="secondary" onClick={onClick} disabled={enqueue.loading}>
        {t("app.customization.aggregation_period.power_outputs.button")}
      </Button>
    </div>
  );
}

const content = css`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: ${spacings.m};
`;
